<template>
  <vx-card title="Crear Proforma">
    <div>
      <vs-button @click="saveProforma">Guardar</vs-button>
    </div>
  </vx-card>
</template>
<script>
export default {
  data() {
    return{
      proformas:
			{
				"proformasid":1,
				"emision":"20210831",
				"proformas_codigo":"P000000001",
				"forma_pago_empresaid":1,
				"facturadoresid":1,
				"clientesid":4,
				"almacenesid":1,
				"centros_costosid":1,
				"vendedoresid":3,
				"tarifasid":1,
				"concepto":"NRO. TESTING PRUEBAS.01",
				"origen":"0",
				"documentosid":0,
				"observacion":"",
				"subtotalsiniva":200,
				"subtotalconiva":267.87,
				"total_descuento":0,
				"subtotalneto":467.87,
				"total_iva":32.144,
				"total":500.01,
				"empresaid":4,
				"usuarioid":2,
				"usuariocreacion":"IMOVIL",
      },
      detalles:[
        {
          "proformasid":1,
						"centros_costosid":1,
						"productosid":2,
						"medidasid":1,
						"almacenesid":1,
						"cantidaddigitada":2,
						"cantidad":2,
						"cantidadfactor":1,
						"precio":100,
						"preciovisible":100,
						"iva":0,
						"precioiva":100,
						"descuento":0
        }
      ]
    }
  },
  methods:{
    saveProforma() {
      let formData = new FormData();
      Object.entries(this.proformas).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append('detalles', JSON.stringify(this.detalles));
      this.$vs.loading();
      this.$http
        .post(this.$server_url + 'api/perseo/transaccion/proformas_crear', formData)
        .then((res) => {
          this.$vs.loading.close();
          console.log("data", res.data);
          if (res.data.fault) {
            this.$vs.notify({
              text: res.data.fault.faultstring,
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            });
            return;
          }
          this.$vs.notify({
            text: 'Se guardo correctamente',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: 'Ocurrio un error',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check'
          });
        })
    },
  }
}
</script>
